import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const videoViewBpContextName = 'video_view_context';
export const videoViewBpContextSchemaVersion = 4;
export type VideoViewBpContext = Fields<
  typeof videoViewBpContextName,
  typeof videoViewBpContextSchemaVersion
>;

const defaults = createNullObject([
  'has_like_available',
  'has_watch_later_available',
  'has_share_available',
  'has_comment_available',
  'existing_like_counts',
  'existing_comment_counts',
  'existing_view_counts',
  'listed_categories_counts',
  'has_ai',
  'viewer_home_view_mode',
]);

export const buildVideoViewBpContext = (
  fields: PartialWithRequired<VideoViewBpContext, 'viewer_home_session_id'>,
) => {
  return {
    video_view_context: new EventContext(videoViewBpContextName, videoViewBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};
